// noinspection JSUnresolvedReference,JSClosureCompilerSyntax

/*
 * Copyright (c) 2025-present TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 */

import { brazeSubscribePriceDrop } from '@theme/braze';
import { AbstractBrazeForm } from '@theme/abstract-braze-form';

/**
 * @typedef {Object} Refs
 * @property {HTMLInputElement} quantityInput
 * @extends {AbstractBrazeForm<Refs>}
 */
class PriceDropForm extends AbstractBrazeForm {
  connectedCallback() {
    super.connectedCallback();

    // check for hash and click button
    const currentUrl = new URL(window.location.href);
    if (currentUrl.hash.replace('#', '') === this.id) {
      this.handleSubmit(new Event('click'));
    }
  }

  /**
   * Inline submit handler
   */
  _handleSubmit() {
    // noinspection JSUnresolvedReference
    if (!Theme?.customer?.logged_in) {
      // link to current URL
      const currentUrl = new URL(window.location.href);
      currentUrl.hash = '#' + this.id;

      // link to login URL with return URL
      const loginUrl = new URL(Theme.routes.login_url, window.location.origin);
      loginUrl.searchParams.set('return_url', currentUrl.toString());

      // redirect to login
      location.href = loginUrl.toString();
      return;
    }

    // subscribe
    if (brazeSubscribePriceDrop(this.dataset.productId)) {
      this.setSuccess();
    } else {
      this.setError(this.dataset.messageErrorNotSaved);
    }
  }
}

if (!customElements.get('price-drop-form')) {
  customElements.define('price-drop-form', PriceDropForm);
}
